module.exports = __webpack_public_path__ + "img/paint_chromatic_corruption.496eee9a.png";